import axios from "axios";

// Base URL untuk API Anda
const API_BASE_URL = "https://api.ptksp.id";

const API = axios.create({ baseURL: API_BASE_URL });
export { API };

// Ambil token dari localStorage
export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

// Buat instance Axios
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Tambahkan middleware untuk menyisipkan Authorization header
api.interceptors.request.use((config) => {
  const token = getToken();

  // Cek jika kita tidak berada di halaman login dan token tersedia
  if (window.location.pathname !== "/login" && token) {
    // Menambahkan Authorization header dengan Bearer token
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Tambahkan middleware untuk menangani error response
api.interceptors.response.use(
  (response) => response, // Biarkan respons sukses tetap berjalan
  (error) => {
    if (error.response && error.response.status === 401) {
      // Hapus token dari localStorage jika status 401 (Unauthorized)
      localStorage.removeItem("token");
    }

    // Lempar kembali error agar bisa ditangani di tempat lain
    return Promise.reject(error);
  }
);

export default api;
